// extracted by mini-css-extract-plugin
export default {"security":"FirstPart_security__w4E8z","shield":"FirstPart_shield__vP0bG","shieldText":"FirstPart_shieldText__dJIok"};